import { Component } from "@kluntje/core";
import { I18nService } from "Services/I18nService";

class FRAContentDisclaimer extends Component {
  constructor() {
    super({
      ui: {
        disclaimer: ".fra-e-content-disclaimer__value :-one",
      },
    });
  }

  /**
   * Lifecycle hook
   */
  afterComponentRender(): void {
    this.generateDisclaimer();
  }

  private generateDisclaimer() {
    const translateService: I18nService = I18nService.getInstance();
    if (!translateService.loaded) return;

    const labelKey = "fraport.travel.components.content.flight.table.disclaimer.label";
    const label = translateService.getKey(labelKey);

    this.ui.disclaimer.innerText = label;
  }
}

customElements.define("fra-e-content-disclaimer", FRAContentDisclaimer);

export default FRAContentDisclaimer;
